import { push } from 'react-router-redux';
import { SubmissionError } from 'redux-form';
import ActionTypes from '../constants/ActionTypes';
import Socium from '../constants/Socium';
import { postJob } from '../api/jobs';
import { getPostcodes } from '../api/voucher';
import { createAction } from 'redux-actions';
import Cookies from 'universal-cookie';

export const customDateKey = `get_quotes_question_${Socium.QUESTION_TIME_GROUP_ID}_0`;

const generateDates = data => {
  const dates = Array.from(Array(3), () => ['', '']);
  Object.keys(data).forEach(key => {
    if (key.includes('custom_date_')) {
      dates[parseInt(key.split('custom_date_')[1], 10)][0] = data[key];
    }
    if (key.includes('custom_time_')) {
      dates[parseInt(key.split('custom_time_')[1], 10)][1] = data[key];
    }
  });
  return dates;
};

const formatDates = data => {
  const formatted = [];
  data.forEach(date => {
    if (date[0]) {
      formatted.push(`${date[0]} ${date[1] || 'Anytime'}`);
    }
  });

  const formattedDates = formatted && formatted.join('\n');
  return formattedDates;
};

const getAttachmentIds = (attachments = []) =>
  attachments.map(attachment => Number(attachment.databaseId));

const getPostcode = (value = '') => parseInt(value.split('-')[0].trim(), 10);

const transformedArrayAnswer = (answer = []) =>
  answer.map((e, i) => e !== null && i).filter(Boolean);

export const transformFormData = formData => {
  return Object.keys(formData).reduce((accum, key) => {
    if (key.includes('custom_date_') || key.includes('custom_time_')) {
      if (!accum[customDateKey]) {
        const dates = generateDates(formData);
        accum[customDateKey] = formatDates(dates);
      }
    } else if (key.includes('get_quotes_question') && Array.isArray(formData[key])) {
      accum[key] = transformedArrayAnswer(formData[key]);
    } else if (key === 'address_full') {
      accum = { ...accum, ...transformAddress(formData.address_full) };
    } else if (key === 'w') {
      if (formData[key]) {
        accum['postcode'] = getPostcode(formData[key]);
      }
      accum['w'] = formData['w'];
    } else if (key === 'attachments' && formData['attachments'] && formData['attachments'].length) {
      accum['attachmentIds'] = getAttachmentIds(formData.attachments);
    } else {
      accum[key] = formData[key];
    }
    return accum;
  }, {});
};

const hasDate = dates => {
  return dates.reduce((r, v) => (v[0].length > 0 ? true : r), false);
};

const convertDate = str => {
  const s = str.split('/');
  return `${s[1]}/${s[0]}/${s[2]}`;
};

const hasInvalidDate = dates => {
  return dates.reduce(
    (r, v) => (v[0].length === 0 ? r : isNaN(Date.parse(convertDate(v[0]))) ? true : r),
    false
  );
};

const areFutureDates = dates => {
  return dates.reduce(
    (r, v) => (Date.parse(convertDate(v[0])) < Date.parse(new Date()) ? false : r),
    true
  );
};

const validateForm = async (form, dates, token) => {
  const errorObj = {};

  if (!form.w) {
    errorObj.w = "We couldn't figure out where you want the job done";
  } else {
    const postcode = parseInt(form.w.split('-')[0].trim(), 10);
    try {
      await getPostcodes(token, postcode);
    } catch (e) {
      errorObj.w = 'Postcode and suburb are not allowed for current service';
    }
  }

  if (hasDate(dates) === false) {
    errorObj[customDateKey] = 'Please provide at least one convenient time';
  } else if (hasInvalidDate(dates) === true) {
    errorObj[customDateKey] = 'Please provide a valid time';
  } else if (areFutureDates(dates) === false) {
    errorObj[customDateKey] = 'Please provide future time';
  }

  if (!form.full_name) {
    errorObj.full_name = 'Please specify your full name';
  }

  if (!form.address_full) {
    errorObj.address_full = 'Please specify your address';
  }

  if (Object.keys(errorObj).length === 0) {
    return;
  }

  throw new SubmissionError(errorObj);
};

const componentForm = {
  subpremise: 'short_name',
  street_number: 'short_name',
  route: 'long_name',
  locality: 'short_name',
  administrative_area_level_1: 'short_name',
  postal_code: 'short_name'
};

const transformAddress = place => {
  const formatted = [];
  if (place !== undefined && place.address_components !== undefined) {
    place.address_components.forEach(address => {
      const addressType = address.types[0];
      if (componentForm[addressType]) {
        formatted[addressType] = address[componentForm[addressType]];
      }
    });
  }
  return formatted;
};

export const requestQuote = form => async (dispatch, getState) => {
  const state = getState();
  const cookies = new Cookies();
  const token = cookies.get(Socium.COOKIE_TOKEN) || '';
  const category = state.category.list || {};
  const dates = generateDates(form);
  const address = form.address_full;

  await validateForm(form, dates, token);

  const formatted = {
    ...transformFormData(form),
    category_id: category.id,
    search_str: `${category.id}|${category.name}`,
    search_practice: `${category.id}|${category.name}`,
    session_id: +new Date(),
    origin_url: typeof window !== 'undefined' && window.location.hostname,
    start_by_details: 'Other',
    storeAddress: address ? 1 : 0,
    address: address.formatted_address ? address.formatted_address : address
  };
  const { data } = await postJob(formatted, token);

  if (data.job) {
    cookies.set(Socium.COOKIE_TOKEN, data.job.token, {
      path: '/'
    });

    dispatch(createAction(ActionTypes.POST_JOB_SUCCESS)(data.job.token));
    dispatch(push(`./success/${data.job.id}?fty=1`));
  }

  // todo error from backend?
};
